import React from 'react';

import { RegisterCompany } from '../components/register-company/register-company';

const RegisterCompanyRoute = () => {
  return <RegisterCompany licenseType="Portal" />;
};

const RegisterDesignCompanyRoute = () => {
  return (
    <RegisterCompany
      licenseType="Design"
      overrideThemeBackgroundImageUrl={'/static/themes/default/images/background-design.jpg'}
    />
  );
};

export { RegisterCompanyRoute, RegisterDesignCompanyRoute };
